<template>
  <ModalContainer
    :showModal="showModal"
    :title="isEdit ? 'Edit Branch' : 'Create New Branch'"
    @closeModal="closeModal"
  >
    <div id="modal-body" class="p-6">
      <AlertDanger
        v-if="alert_danger"
        :text="alert_text"
        @closeAlertDanger="hideAlertDanger()"
      />
      <InputForm
        v-model="branch.name"
        label="Name"
        id="branch-name"
        input_class="w-full mb-3"
        placeholder="e.g. SBY / Surabaya"
        type="text"
      />
      <InputForm
        v-model="branch.location"
        label="Location: City / Country"
        id="branch-location"
        input_class="w-full mb-3"
        placeholder="e.g. Surabaya / Singapore"
        type="text"
      />
      <InputForm
        v-model="branch.address"
        label="Address"
        id="branch-address"
        input_class="w-full mb-3"
        placeholder="e.g. Jl. Mayjend Sungkono"
        type="text"
      />
      <InputForm
        v-model="branch.phone"
        label="Phone Number"
        id="branch-phone"
        input_class="w-full mb-5"
        placeholder="e.g. 08123456789"
        type="number"
      />
    </div>
    <div class="modal-footer pb-6">
      <div class="flex justify-center gap-2">
        <Button
          id="close-modal"
          button_text="Close"
          @click="closeModal"
        />
        <SubmitButton
          @click="submit()"
          id="submit"
          button_text="Submit"
          :is_loading="loadingSubmit"
          :is_disabled="loadingSubmit"
        />
      </div>
    </div>
  </ModalContainer>
</template>
<script>
import Button from "../buttons/Button.vue";
import SubmitButton from "../form/SubmitButton.vue";
import InputForm from "@/components/form/InputForm.vue";
import AlertDanger from "@/components/alerts/AlertDanger.vue";
import ModalContainer from "@/components/modals/ModalContainer.vue";
import { mapActions } from "vuex";
import { validationPhoneNumber } from "@/helpers/validation";

export default {
  name: "ModalAddBranch",
  props: {
    branchData: {
      type: Object,
      default: {},
    },
  },
  emits: ["openAlertSuccess_BranchCreated", "openAlertSuccess_BranchUpdated", "closeModal"],
  components: {
    InputForm,
    Button,
    SubmitButton,
    AlertDanger,
    ModalContainer,
  },
  data() {
    return {
      alert_danger: false,
      alert_text: "",

      showModal: true,
      loadingSubmit: false,
      isEdit: false,

      branch: {
        id: null,
        name: '',
        location: '',
        address: '',
        phone: ''
      },
    };
  },
  async created() {
    // console.log('branch to edit: ', this.branchData);
    if(this.branchData) {
      this.isEdit = true;
      this.branch.id = this.branchData.id;
      this.branch.name = this.branchData.name;
      this.branch.location = this.branchData.location;
      this.branch.address = this.branchData.address;
      this.branch.phone = this.branchData.phone;
    }
  },
  methods: {
    ...mapActions("branches", ["createBranch", "updateBranch"]),
    validationPhoneNumber,

    closeModal() {
      this.showModal = false;
      setTimeout(() => {
        this.$emit("closeModal");
      }, 100);
    },
    async submit() {
      if (!this.branch.name) {
        this.alert_danger = true;
        this.alert_text = "Nama Branch harus diisi!";
        return;
      }
      // if (!validationPhoneNumber(this.branch.phone)) {
      //   this.alert_danger = true;
      //   this.alert_text =
      //     "Format no telepon terdiri dari 10 - 13 karakter angka";
      //   return;
      // }
      try {
        if (this.isEdit) {
          this.branch.phone = String(this.branch.phone);
          this.loadingSubmit = true;
          await this.updateBranch(this.branch);
          this.$emit('openAlertSuccess_BranchUpdated');
          this.loadingSubmit = false;
        }
        else {
          this.loadingSubmit = true;
          await this.createBranch(this.branch);
          this.$emit('openAlertSuccess_BranchUpdated');
          this.loadingSubmit = false;
        }
        this.closeModal();
      }
      catch (error) {
        console.error(error);
        this.alert_danger = true;
        this.alert_text = error;
      }
    },
    hideAlertDanger() {
      this.alert_danger = false;
      this.alert_text = "";
    },
  },
};
</script>